export default __webpack_public_path__ + "static/media/monitor.c9aeb711.png";